import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { toast } from 'react-toastify';
import API_BASE_URL from '../config/baseUrl';

const SetMessagePage = () => {
  const navigate = useNavigate();
  const { accessToken, user } = useSelector(function(state) {
    return state.auth;
  });

  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(function() {
    if (user?.userTypeInfo !== 7) {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  const fetchMessage = async function() {
    setLoading(true);
    setError(null);

    try {
      if (!accessToken) {
        setError('No access token found');
        setLoading(false);
        return;
      }

      const response = await axios.post(
        API_BASE_URL + '/message/get-message',
        {},
        {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        }
      );

      const data = response.data;
      if (data.status === false) {
        setError(data.message || 'Failed to fetch message');
        setMessage('');
      } else {
        setMessage(data.data || '');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch message');
    } finally {
      setLoading(false);
    }
  };

  useEffect(function() {
    fetchMessage();
  }, []);

  const handleSave = async function() {
    if (saving) return;
    setSaving(true);
    setError(null);

    try {
      if (!accessToken) {
        toast.error('No access token found');
        setSaving(false);
        return;
      }

      const response = await axios.post(
        API_BASE_URL + '/message/set-message',
        { message: message },
        {
          headers: {
            Authorization: 'Bearer ' + accessToken,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.data?.status === false) {
        toast.error(response.data.message || 'Failed to update message');
        setError(response.data.message || 'Failed to update message');
      } else {
        toast.success('Message updated successfully!');
        fetchMessage();
      }
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Failed to update message';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setSaving(false);
    }
  };

  const handleBack = function() {
    navigate(-1);
  };

  return (
    <div className="w-full bg-white rounded-lg shadow">
      <div className="border-b border-gray-200 px-6 py-4 bg-[#0F2327] rounded-t-lg">
        <div className="flex justify-between items-center">
          <h2 className="text-xl font-semibold text-white">Set Message</h2>
          <button
            onClick={handleBack}
            className="px-4 py-2 bg-white/10 hover:bg-white/20 text-white rounded transition-colors"
          >
            Back
          </button>
        </div>
      </div>

      <div className="p-6">
        {error && (
          <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
            {error}
          </div>
        )}

        <div className="max-w-2xl">
          <label className="block text-sm font-semibold text-gray-700 mb-2">
            Set Message
          </label>
          <textarea
            value={message}
            onChange={function(e) { setMessage(e.target.value); }}
            rows={5}
            placeholder="Enter message..."
            disabled={loading}
            className="w-full rounded border border-gray-300 px-3 py-2 text-gray-700 shadow-sm focus:border-[#0F2327] focus:outline-none focus:ring-2 focus:ring-[#0F2327]/30 disabled:bg-gray-100"
          />

          <div className="mt-4 flex items-center gap-3">
            <button
              onClick={handleSave}
              disabled={loading || saving}
              className="px-4 py-2 bg-[#0F2327] hover:bg-[#1a3439] text-white rounded transition-colors disabled:opacity-60"
            >
              {saving ? 'Saving...' : 'Set Message'}
            </button>
            {loading && (
              <span className="text-sm text-gray-500">Loading message...</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetMessagePage;
